export default __webpack_public_path__ + "static/scitely-12a8feef07567cb10713dde5382105a5.png";